// season.js
// Derives a human-readable season label from any Firestore Timestamp or JS Date.
// Spring = Mar–May, Summer = Jun–Aug, Fall = Sep–Nov, Winter = Dec–Feb.
// Winter straddles years: Dec 2026 and Jan/Feb 2027 are both "Winter 2026".
//
// Usage:
//   getSeason(order.createdAt)      → "Spring 2026"
//   seasonOptions(shifts, s => s.closedAt) → ["Spring 2026", "Winter 2025", ...]

export function getSeason(ts) {
  if (!ts) return null;
  const d = ts?.toDate ? ts.toDate() : (ts instanceof Date ? ts : null);
  if (!d || isNaN(d.getTime())) return null;
  const m = d.getMonth(); // 0-indexed
  const y = d.getFullYear();
  if (m >= 2 && m <= 4)  return `Spring ${y}`;
  if (m >= 5 && m <= 7)  return `Summer ${y}`;
  if (m >= 8 && m <= 10) return `Fall ${y}`;
  return `Winter ${m === 11 ? y : y - 1}`;
}

// Returns sorted unique season labels (newest first) from an array of items.
// getTs: fn(item) => Timestamp | Date | null
export function seasonOptions(items, getTs) {
  const seen = new Set();
  items.forEach(item => {
    const s = getSeason(getTs(item));
    if (s) seen.add(s);
  });
  return [...seen].sort().reverse();
}
